import { Building2, Database, Tag } from "lucide-react";

type Stats = { aggregates: number; tags: number; tenants: number };

export function StatsRow({ stats }: { stats: Stats | null }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <StatCard
        icon={<Database className="w-4 h-4" />}
        label="Aggregates ingested"
        value={stats?.aggregates ?? 0}
        sublabel="k-thresholded buckets persisted"
      />
      <StatCard
        icon={<Tag className="w-4 h-4" />}
        label="Tag-rows total"
        value={stats?.tags ?? 0}
        sublabel="semantic events counted"
      />
      <StatCard
        icon={<Building2 className="w-4 h-4" />}
        label="Active tenants"
        value={stats?.tenants ?? 0}
        sublabel="brand-isolated partitions"
      />
    </div>
  );
}

function StatCard({
  icon, label, value, sublabel,
}: {
  icon: React.ReactNode;
  label: string;
  value: number;
  sublabel: string;
}) {
  return (
    <div className="rounded-lg border border-zinc-800 bg-zinc-900/40 p-4">
      <div className="flex items-center gap-2 text-zinc-400 text-xs uppercase tracking-wider">
        {icon} {label}
      </div>
      <div className="mt-2 text-3xl font-semibold tabular-nums">{value.toLocaleString()}</div>
      <div className="text-xs text-zinc-500 mt-1">{sublabel}</div>
    </div>
  );
}
